YP.TypeTicketCategoriesManager = function() {
    return {
        init: function() {
            YP.TypeTicketCategoriesManager().initSortable();
            YP.ModalManager().setPostCallSuccess(function() {
                YP.TypeTicketCategoriesManager().initSortable();
            });
        },
        initSortable: function(e) {
            YP.TypeTicketCategoriesManager().initDragCategory();
            YP.TypeTicketCategoriesManager().initDragNoCategory();
            YP.TypeTicketCategoriesManager().initSortInCategory();
            YP.TypeTicketCategoriesManager().initSortNoCategory();
        },

        initDragCategory: function() {
            $("tbody.category-container").droppable({
                activeClass: "c-table__body_drop-active",
                hoverClass: "c-table__body_hover",
                tolerance: "pointer",
                refreshPositions: true,
                accept: function(element) {
                    if ($(this).attr('id') == element.parent().attr('id')) {
                        return false;
                    };
                    if (element.hasClass('sub-category')) {
                        return true;
                    }
                    if (element.hasClass('no-category')) {
                        return true;
                    }
                },
                drop: function(event, ui) {
                    if (ui.draggable.is("tr")) {
                        tr = ui.draggable.clone();
                    } else {
                        tr = ui.draggable.clone().find('tr');
                    }
                    $("<tr></tr>").attr('class', 'c-table__row c-table__row--draggable js-ticket-rate sub-category').attr('id', tr.attr('id')).html(tr.html()).appendTo($(this));
                    ui.draggable.remove();
                    $.post($('.table-typeticket').data('setcaturl'), {
                        typeTicketId: tr.attr('id'),
                        categoryId: $(this).attr('id')
                    });
                    YP.TypeTicketCategoriesManager().cleanTable();
                }
            });
        },
        initDragNoCategory: function() {
            $(".drag-no-category").droppable({
                activeClass: "c-table__body_drop-active",
                hoverClass: "c-table__body_hover",
                tolerance: "pointer",
                accept: ".category-container tr.js-ticket-rate",
                refreshPositions: true,
                drop: function(event, ui) {
                    tr = ui.draggable.clone();
                    $("<tbody class='no-category'></tbody>").html($("<tr></tr>").attr('class', 'c-table__row c-table__row--draggable js-ticket-rate').attr('id', tr.attr('id')).html(tr.html())).insertBefore($(this));
                    ui.draggable.remove();
                    $.post($('.table-typeticket').data('setcaturl'), {
                        typeTicketId: tr.attr('id'),
                        categoryId: $(this).attr('id')
                    });
                    YP.TypeTicketCategoriesManager().cleanTable();
                }
            });
        },
        initSortInCategory: function() {
            $(".category-container").sortable({
                items: ".js-ticket-rate.sub-category",
                refreshPositions: true,
                handle: ".js-position-handle",
                placeholder: "c-table__body_highlight",
                helper: function(e, element) {
                    var $originals = element.find('td');
                    var $helper = element.clone().appendTo('#helper');
                    $helper.find('td').each(function(index) {
                        $(this).width($originals.eq(index).width());
                    });
                    return $helper;

                },
                update: function() {
                    YP.TypeTicketCategoriesManager().cleanTable();
                    YP.TypeTicketCategoriesManager().sortTickets();
                }
            });
        },
        initSortNoCategory: function() {
            $(".table-typeticket").sortable({
                items: "> tbody",
                accept: ".js-ticket-rate",
                handle: ".js-position-handle",
                refreshPositions: true,
                placeholder: "c-table__body_highlight",
                helper: function(e, element) {
                    var $originals = element.find('td');
                    var $helper = element.clone();
                    $helper.find('td').each(function(index) {
                        $(this).width($originals.eq(index).width());
                    });
                    return $helper;
                },
                start: function(event, ui) {
                    ui.item.toggleClass("c-table__body_highlight");
                },
                stop: function(event, ui) {
                    ui.item.toggleClass("c-table__body_highlight");
                },
                update: function() {
                    YP.TypeTicketCategoriesManager().cleanTable();
                    YP.TypeTicketCategoriesManager().sortTickets();
                }
            });
        },
        cleanTable: function() {
            dropNoCategoryTemplate = '<tbody class="drag-no-category c-table__body_zindex"><tr class="c-table__row c-table__row_border_top_none"><td class="c-table__cell p-0" colspan="9"></td></tr></tbody>';
            $('.table-typeticket').find('.drag-no-category').remove();
            tbodyCount = $('.table-typeticket').find('tbody').length;
            $('.table-typeticket').find('tbody').each(function(index) {
                if (index === 0) {
                    $(this).before($(dropNoCategoryTemplate));
                }

                if ($(this).hasClass('category-container')) {
                    $(this).after($(dropNoCategoryTemplate));
                }

                if (index == (tbodyCount + 1)) {
                    $(this).after($(dropNoCategoryTemplate));
                }

            });
            YP.TypeTicketCategoriesManager().initDragNoCategory();
        },
        sortTickets: function() {
            order = "";
            $('.table-typeticket').find('.js-ticket-rate').each(function(index) {
                order += "ticket[]=" + $(this).attr('id') + "&";
            });
            $.post($('.table-typeticket').data('sorturl'), {
                order: order
            });
            //Update category number sold
            $('.category-container').each(function(index) {
                var catSold = $(this).find('.js-type__ticket-sold').toArray().reduce(function(sum,element) {
                    return sum + Number($(element).html());
                }, 0);
                $(this).find('.js-ticketing__category-sold').html(catSold);
            });
        }
    };
};

window.addEventListener("load", function() {
    YP.TypeTicketCategoriesManager().init();
});
